import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./propertiesModal.html";
class PropertiesModal extends LightningElement {
  constructor() {
    super();
    this.isModalOpen = void 0;
    this.modalTitle = void 0;
    this.orgUserDetails = void 0;
    this.closeModal = () => {
      this.isModalOpen = false;
    };
  }
}
_registerDecorators(PropertiesModal, {
  publicProps: {
    isModalOpen: {
      config: 0
    },
    modalTitle: {
      config: 0
    },
    orgUserDetails: {
      config: 0
    }
  },
  fields: ["closeModal"]
});
export default _registerComponent(PropertiesModal, {
  tmpl: _tmpl
});